import { ReactElement, ReactNode } from 'react';
import { OrientationContainer, OrientationContent } from '../../styles';
import { useTranslation } from 'react-i18next';

interface OrientationProps {
  title: string;
  orientations: string[];
  children: ReactNode;
}

export function Orientation({
  children,
  orientations,
  title,
}: Readonly<OrientationProps>): ReactElement {
  const { t } = useTranslation();

  return (
    <>
      <h2>{title}</h2>
      <OrientationContainer>
        <OrientationContent>
          <h3>{t('orientacoes')}</h3>
          {orientations.map((item, index) => (
            <span key={`orientation-${index}-${item.slice(0, 5)}`}>
              {item}
            </span>
          ))}
        </OrientationContent>
        {children}
      </OrientationContainer>
    </>
  );
}
